import { render, staticRenderFns } from "./LabelAndInput.vue?vue&type=template&id=86fa8130&"
import script from "./LabelAndInput.vue?vue&type=script&lang=js&"
export * from "./LabelAndInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports